import firebase, { database } from "../firebase";
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import axios from "axios";

export function getTransactionTypes(registrationID) {
  return async (dispatch, getState) => {
    // let addMessage = firebase.functions().httpsCallable("getTransactionTypes");
    // return addMessage({ registrationID: registrationID }).then(function(
    //   result
    // ) {
    //   // console.log(result.data)
    //   let transactionTypes = result.data;
    //   dispatch({ type: actionTypes.TRANSACTION_TYPES_GET, transactionTypes });
    // });
    //9 Mar 26
    // /setup/moduleConfiguration/
    const token = getState().user.uat;
    let response = await axios.get(
      constants.API_URL + "/setup/moduleConfiguration/",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log("response", response);
    if (response && response.data && response.data.moduleConfigurations) {
      let transactionTypes = response.data.moduleConfigurations;
      dispatch({ type: actionTypes.TRANSACTION_TYPES_GET, transactionTypes });
    }
  };
}

export function deleteTransactionType(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        `${constants.API_URL}/setup/moduleConfiguration/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return true;
      } else {
        alert(response.data.message || "Failed to delete module");
        return false;
      }
    } catch (error) {
      console.error("Delete module error:", error);
      alert("Error while deleting module");
      return false;
    }
  };
}

export function saveTransactionType(transactionType, key)  {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/setup/moduleConfiguration/${key}`,
          transactionType,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/setup/moduleConfiguration/`,
          transactionType,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


